import React from 'react'
import { Box, Typography } from '@mui/material'
import ImageUpload from 'src/v3/components/upload-image'

type ImageUploadStepProps = {
  image: File | undefined
  onImageChange: (image: File | undefined) => void
}

export default ({ image, onImageChange }: ImageUploadStepProps) => (
  <Box sx={{ maxWidth: 600, margin: '0 auto' }}>
    <Typography variant="h6" sx={{ mb: 3 }}>
      Upload your certificate background image
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
      Images will be cropped to match the certificate dimensions (11" × 8.5"
      landscape)
    </Typography>

    <ImageUpload
      id="certificate-background"
      type="landscape"
      image={image}
      setImage={onImageChange as any}
    />
  </Box>
)
